"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.count = exports.countWith = exports.countBy = void 0;

var _pipe = require("../pipe/pipe");

var _curry = require("../curry/curry");

var _isMatch = require("../is-match/is-match");

var _is = require("../is/is");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _countBy = function _countBy(_fn, _source) {
  var source = (0, _is.isObject)(_source) ? Object.entries(_source) : _source;
  var fn = Array.isArray(_fn) ? _pipe.pipe.apply(void 0, _toConsumableArray(_fn)) : _fn;
  var result = 0;

  for (var i = 0, length = source.length; i < length; i++) {
    if (fn.call(null, source[i]) === true) {
      result = result + 1;
    }
  }

  return result;
};
/**
 * Count the number of elements that satisfies a function
 *
 * @param {Function|Function[]} fn     Match function
 * @param {Array|Object}        source Source array, if object passed,
 *                                     Object.entries will be iterated over
 *
 * @return  {Number}
 *
 * @name count
 * @tag Array
 * @signature (fn: Function|Function[]) => (source: Array|Object): Number
 * @signature (fn: Function|Function[], source: Array|Object): Number
 *
 * @see {@link countWith}
 *
 * @example
 * const scores = [{
 *  name   : "Bob",
 *  score  : 1,
 *  subject: "Math"
 * }, {
 *  name   : "Alice",
 *  score  : 10,
 *  subject: "Math"
 * }, {
 *  name   : "Hatter",
 *  score  : 10,
 *  subject: "Math"
 * }]
 *
 * count(element => element.score === 10)(scores)
 * // => 2
 */


var countBy = (0, _curry.curry)(_countBy);
/**
 * Count elements in array or object that match object
 *
 * @param {Object}       subset Match object
 * @param {Array|Object} source Source array, if object passed, Object.entries
 *                              will be iterated over
 *
 * @return {Number}
 *
 * @name countWith
 * @tag Array
 * @signature (subset: Object) => (source: Array|Object): Number
 * @signature (subset: Object, source: Array|Object): Number
 *
 * @see {@link count}
 *
 * @example
 * const scores = [{
 *  name   : "Bob",
 *  score  : 1,
 *  subject: "Math"
 * }, {
 *  name   : "Alice",
 *  score  : 10,
 *  subject: "Math"
 * }, {
 *  name   : "Hatter",
 *  score  : 10,
 *  subject: "Math"
 * }]
 *
 * countWith(
 *   { score: gt(5) },
 *   scores
 * )
 * // => 2
 */

exports.countBy = countBy;
var countWith = (0, _curry.curry)(function (subset, source) {
  return _countBy((0, _isMatch.isMatch)(subset), source);
});
exports.countWith = countWith;

var count = function count(source) {
  var type = Array.isArray(source) ? "array" : _typeof(source);

  switch (type) {
    case "array":
    case "string":
      return source.length;

    case "object":
      {
        if (source === null) {
          return 0;
        }

        var result = 0,
            key;

        for (key in source) {
          if (source.hasOwnProperty(key)) {
            result = result + 1;
          }
        }

        return result;
      }

    default:
      return 0;
  }
};

exports.count = count;